var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBenefitHardPriceFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81689 3.20996C7.55289 1.47396 8.42089 0.605957 9.49889 0.605957C10.5779 0.605957 11.4459 1.47396 13.1809 3.20996L17.6009 7.62896C19.3359 9.36396 20.2039 10.232 20.2039 11.311C20.2039 12.389 19.3359 13.257 17.5999 14.993C15.8639 16.729 14.9959 17.597 13.9179 17.597C12.8389 17.597 11.9709 16.729 10.2359 14.993L5.81589 10.574C4.08189 8.83896 3.21289 7.97096 3.21289 6.89196C3.21289 5.81396 4.08089 4.94596 5.81689 3.20996Z",
    fill: "url(#paint0_linear_1181_57179)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81689 3.20996C7.55289 1.47396 8.42089 0.605957 9.49889 0.605957C10.5779 0.605957 11.4459 1.47396 13.1809 3.20996L17.6009 7.62896C19.3359 9.36396 20.2039 10.232 20.2039 11.311C20.2039 12.389 19.3359 13.257 17.5999 14.993C15.8639 16.729 14.9959 17.597 13.9179 17.597C12.8389 17.597 11.9709 16.729 10.2359 14.993L5.81589 10.574C4.08189 8.83896 3.21289 7.97096 3.21289 6.89196C3.21289 5.81396 4.08089 4.94596 5.81689 3.20996Z",
    fill: "white",
    fillOpacity: 0.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.55816 11.316L1.03816 16.834C0.696159 17.177 0.525159 17.348 0.422159 17.526C0.285065 17.7634 0.212891 18.0328 0.212891 18.307C0.212891 18.5812 0.285065 18.8505 0.422159 19.088C0.525159 19.266 0.696159 19.438 1.03916 19.78C1.38116 20.122 1.55216 20.294 1.73116 20.397C1.96861 20.5341 2.23797 20.6062 2.51216 20.6062C2.78635 20.6062 3.05571 20.5341 3.29316 20.397C3.47116 20.294 3.64316 20.122 3.98516 19.78L9.50316 14.261L6.55816 11.316ZM16.8682 6.89598L17.2412 6.52398C17.5832 6.18098 17.7552 6.00998 17.8582 5.83198C17.9953 5.59452 18.0674 5.32517 18.0674 5.05098C18.0674 4.77679 17.9953 4.50743 17.8582 4.26998C17.7552 4.09098 17.5832 3.91998 17.2412 3.57798C16.8992 3.23498 16.7272 3.06398 16.5492 2.96098C16.3117 2.82388 16.0423 2.75171 15.7682 2.75171C15.494 2.75171 15.2246 2.82388 14.9872 2.96098C14.8092 3.06398 14.6372 3.23498 14.2952 3.57798L13.9222 3.95098L16.8682 6.89698V6.89598Z",
    fill: "url(#paint1_linear_1181_57179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55816 11.316L1.03816 16.834C0.696159 17.177 0.525159 17.348 0.422159 17.526C0.285065 17.7634 0.212891 18.0328 0.212891 18.307C0.212891 18.5812 0.285065 18.8505 0.422159 19.088C0.525159 19.266 0.696159 19.438 1.03916 19.78C1.38116 20.122 1.55216 20.294 1.73116 20.397C1.96861 20.5341 2.23797 20.6062 2.51216 20.6062C2.78635 20.6062 3.05571 20.5341 3.29316 20.397C3.47116 20.294 3.64316 20.122 3.98516 19.78L9.50316 14.261L6.55816 11.316ZM16.8682 6.89598L17.2412 6.52398C17.5832 6.18098 17.7552 6.00998 17.8582 5.83198C17.9953 5.59452 18.0674 5.32517 18.0674 5.05098C18.0674 4.77679 17.9953 4.50743 17.8582 4.26998C17.7552 4.09098 17.5832 3.91998 17.2412 3.57798C16.8992 3.23498 16.7272 3.06398 16.5492 2.96098C16.3117 2.82388 16.0423 2.75171 15.7682 2.75171C15.494 2.75171 15.2246 2.82388 14.9872 2.96098C14.8092 3.06398 14.6372 3.23498 14.2952 3.57798L13.9222 3.95098L16.8682 6.89698V6.89598Z",
    fill: "white",
    fillOpacity: 0.17
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1181_57179",
    x1: 20.2039,
    y1: 0.605955,
    x2: 2.37045,
    y2: 1.59086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1181_57179",
    x1: 18.0674,
    y1: 2.75171,
    x2: -0.672367,
    y2: 3.78667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefitHardPriceFloor);
export default __webpack_public_path__ + "static/media/icon-benefit--hard-price-floor.be3a7f7b93fa00e58d977cfbca4b8e07.svg";
export { ForwardRef as ReactComponent };